import CustomRadio from 'app/components/CustomRadio/CustomRadio';

export default CustomRadio;
